import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import ruTranslation from './locales/ru/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';
import hiTranslation from './locales/hi/translation.json';
import ptTranslation from './locales/pt/translation.json';

// the translations
const resources = {
    en: {
        translation: enTranslation
    },
    es: {
        translation: esTranslation
    },
    ru: {
        translation: ruTranslation
    },
    de: {
        translation: deTranslation
    },
    fr: {
        translation: frTranslation
    },
    zh: {
        translation: zhTranslation
    },
    ja: {
        translation: jaTranslation
    },
    hi: {
        translation: hiTranslation
    },
    pt: {
        translation: ptTranslation
    }
};

i18n
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next
    .use(initReactI18next)
    // init i18next
    .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

// For testing - uncomment the line below to force a specific language
// i18n.changeLanguage('en');

export default i18n;